/* eslint-disable @typescript-eslint/no-explicit-any */
import { safeToNumber } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

/**
 * Fetch roles for the given business.
 *
 * @returns {Object} A redux TockApi action.
 */
export function fetchRoles(): ApiAction {
  return {
    TockApi: {
      getListProto: '/admin/business/role',
      type: AppConstants.BUSINESS_ROLES_FETCH_ALL,
    },
  };
}

/**
 * Insert a patron's assigned business role.
 *
 * @param {Object} assignedBusinessRole to insert for a patron.
 * @returns {Object} A redux TockApi action.
 */
export function addRole(assignedBusinessRole: any): ApiAction {
  return {
    TockApi: {
      postProto: '/admin/patron/role',
      type: AppConstants.BUSINESS_ROLES_ADD,
      request: assignedBusinessRole,
      toast: 'Team member added',
    },
  };
}

/**
 * Update a patron's assigned business role.
 *
 * @param {Object} assignedBusinessRole to update for a patron.
 * @returns {Object} A redux TockApi action.
 */
export function updateRole(assignedBusinessRole: any): ApiAction {
  return {
    TockApi: {
      putProto: `/admin/patron/${safeToNumber(assignedBusinessRole.patron.id)}/role`,
      type: AppConstants.BUSINESS_ROLES_UPDATE,
      request: assignedBusinessRole.roles,
      toast: 'Team member updated',
    },
  };
}
